import { when } from '@execonline-inc/maybe-adapter';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../../Translations';
import LearningCollectionEditStore from '../../../../../../Edit/Store';
import { ExperienceResource } from '../../../Types';
import { SectionContext } from '../../../../../../Types';

interface Props {
  filteredExperiences: ExperienceResource[];
  learningCollectionStore: LearningCollectionEditStore;
  totalUnfilteredCount: number;
  context: SectionContext;
}

const allowBulkAddPrograms = (
  resultsCount: number,
  totalUnfilteredCount: number,
  learningCollectionStore: LearningCollectionEditStore,
  context: SectionContext,
): Maybe<{}> =>
  when(
    resultsCount <= totalUnfilteredCount &&
      resultsCount > 1 &&
      learningCollectionStore.experienceStores(context).length != resultsCount,
    {},
  );

const BulkAdder: React.FC<Props> = ({
  filteredExperiences,
  learningCollectionStore,
  totalUnfilteredCount,
  context,
}) =>
  allowBulkAddPrograms(
    filteredExperiences.length,
    totalUnfilteredCount,
    learningCollectionStore,
    context,
  )
    .map(() => (
      <button
        type="button"
        onClick={() =>
          learningCollectionStore.bulkAddExperienceStores(context, filteredExperiences)
        }
        className="m-2 rounded-md bg-teal-600 px-3 py-2 text-xs text-white"
      >
        <T kind="Add all filtered programs" />
      </button>
    ))
    .getOrElse(() => <></>);

export default observer(BulkAdder);
